const showMoreButtons = document.querySelectorAll<HTMLButtonElement>('.js-show-more');

for (const showMoreButton of showMoreButtons) {
  const showMoreContainerId = showMoreButton.getAttribute('aria-controls');
  const showMoreContainer = document.querySelector<HTMLElement>(`#${showMoreContainerId}`);

  if (showMoreContainer) {
    showMoreButton.addEventListener('click', () => {
      const isExpanded = showMoreButton.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !isExpanded;
      showMoreButton.setAttribute('aria-expanded', String(nextExpanded));
      showMoreContainer.classList.toggle('active', nextExpanded);

      const { labelExpanded = '', labelCollapsed = '' } = showMoreButton.dataset;

      if (labelExpanded && labelCollapsed) {
        showMoreButton.textContent = nextExpanded ? labelCollapsed : labelExpanded;
      }
    });
  }
}
